/**
 * Notice.jsx
 * Created by michaelbray on 3/5/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../sharedComponents/icons/Icons';

const propTypes = {
    children: PropTypes.node,
    showNotice: PropTypes.bool,
    showClose: PropTypes.bool,
    closeNotice: PropTypes.func,
    noticeType: PropTypes.string
};

export default class Notice extends React.Component {
    generateIcon(noticeType) {
        switch (noticeType) {
            case 'warning':
                return (<Icons.IconWarning className="rec-icon-warning" />);
            case 'info':
                return (<Icons.IconInfo className="rec-icon-info" />);
            case 'success':
                return (<Icons.IconCheckCircle className="rec-icon-success" />);
            case 'error':
                return (<Icons.IconError className="rec-icon-error" />);
            default:
                return (<Icons.IconInfo className="rec-icon-info" />);
        }
    }

    render() {
        const noticeIcon = this.generateIcon(this.props.noticeType);

        let hideNoticeClass = '';
        if (!this.props.showNotice) {
            hideNoticeClass = 'hide';
        }

        let hideCloseButtonClass = '';
        if (!this.props.showClose) {
            hideCloseButtonClass = 'hide';
        }

        return (
            <div className={hideNoticeClass}>
                <div className={`rec-notification-${this.props.noticeType}`}>
                    <span className="rec-notification-icon">
                        {noticeIcon}
                    </span>
                    <div className="rec-notification-body">
                        {this.props.children}
                    </div>
                    <button
                        className={`rec-notification-close ${hideCloseButtonClass}`}
                        onClick={this.props.closeNotice}
                        aria-label="Close notification">
                        <Icons.IconClose className="rec-icon-close" />
                    </button>
                </div>
            </div>
        );
    }
}

Notice.propTypes = propTypes;
